/**
 * @created        15/09/2023 - 16:52
 * @author         Nariman Palangi
 * @user           ragnarok
 * @organization
 * @project        Azmiun
 * @file name      AxiosReadClient.js
 * @file dir       src/repository/clients
 */
import axios from "axios";
import { useApiResponseHandler } from "@/composable/errorHandler";

/**
 * @description window protocol https | https
 * @type { String }
 * */
// const PROTOCOL = window.location.protocol;

/**
 * @description set host name azmiun.com
 * @type { String }
 * */
const HOST =  import.meta.env.VITE_APP_MAIN_READ_URL || 'https://student.classino.com/read'

/**
 * @description set base domain
 * @type { String }
 * */
// const baseDomain = `${PROTOCOL}//${HOST}`
const baseDomain = `${HOST}`


/**
 * @description set api base url
 * @type { String }
 * */
const baseURL = `${baseDomain}/v1/api/site`; // Incase of /api/v1;
// ALL DEFAULT CONFIGURATION HERE
export const AxiosRead =  axios.create({
    baseURL,
    headers: {
        'Accept': 'application/json' ,
        'os' : 'web',
        'release' : '2',
    }
});

AxiosRead.interceptors.request.use(
    async (request) => {
        return request;
    },
    async (error) => {
        return Promise.reject(error);
    }
);

// response and error handler
AxiosRead.interceptors.response.use(
    async (response) => {
        return useApiResponseHandler.response(response);
    },
    async (error) => {
        return useApiResponseHandler.error(error);
    }
);
